export const COMMON_GA = 'commonGA';
export const LANDING_GA = 'landingGA';
